<article *ngIf="content" role="main">
  <header class="page-header">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h1>{{ content.title }}<small *ngIf="!content.id" class="mjs-job-preview-title badge bg-light small text-primary">PREVIEW</small></h1>
        </div>
      </div>
    </div>
  </header>
  <div class="job-actions">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <dl class="single-job-meta">
            <div>
              <dt><span>Ref no: </span></dt>
              <dd><span>{{ content.job_number || content.id }}</span></dd>
            </div>
            <div>
              <dt><span>Published: </span></dt>
              <dd><span>{{ (content.start_date | mjsJobClosingDate) | date:'dd/MM/yyyy' }}</span></dd>
            </div>
            <div>
              <dt><span>Closes: </span></dt>
              <dd><span>{{ (content.end_date | mjsJobClosingDate) | date: 'dd/MM/yyyy' }}</span></dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-clean">
    <div class="container">
      <div class="row">
        <div class="col">
          <dl class="job-details">
            <div>
              <dt><span>Location: </span></dt>
              <dd *ngIf="content.locations && content.locations.length > 0">
                <span [innerHtml]="content.locations && content.locations.length > 0 ? locationName(content.locations[0]) : 'Location not available'"></span>
                  <button
                    *ngIf="content.locations.length > 1"
                    class="btn btn-link py-0 dropdown-toggle"
                    data-toggle="collapse" data-target="#locations-collapse" [attr.aria-expanded]="locationsOpen ? 'true': 'false'" aria-controls="locations-collapse"
                    (click)="locationsOpen = !locationsOpen">
                  + {{ content.locations.length - 1 }} more
                  </button>
                <ul class="list-unstyled" class="collapse" id="locations-collapse" [ngClass]="{ show: locationsOpen }">
                  <li class="border-top py-1" *ngFor="let item of content.locations | slice:1">{{ locationName(item) }}</li>
                </ul>
              </dd>
            </div>
            <div>
              <dt><span>{{ content.compensation_period == 'Year' ? 'Salary' : 'Rate' }}: </span></dt>
              <dd><span>
                {{ content | mjsJobSalaryDisplay }}
              </span></dd>
            </div>
            <div *ngIf="content.c_type_name">
              <dt><span>Contract Type: </span></dt>
              <dd><span>{{ content.c_type_name }}</span></dd>
            </div>
            <div *ngIf="content.p_type_name">
              <dt><span>Position Type: </span></dt>
              <dd><span>{{ content.p_type_name }}</span></dd>
            </div>
            <div *ngIf="content.work_time_count">
              <dt><span>Hours: </span></dt>
              <dd><span>{{ content.work_time_count }} {{ content.work_time_unit.toLowerCase() }} per {{ content.work_time_period.toLowerCase()  }}</span></dd>
            </div>
            <div *ngIf="toInteger(content.work_from_home) > 0">
              <dt><span>Work From Home: </span></dt>
              <dd>
                <span class="text-capitalize">
                  <ng-container [ngSwitch]="content.work_from_home">
                    <!-- <ng-container *ngSwitchCase="0">Not available</ng-container> -->
                    <ng-container *ngSwitchCase="1">Yes</ng-container>
                    <ng-container *ngSwitchCase="2">Hybrid</ng-container>
                  </ng-container>
                </span>
              </dd>
            </div>
          </dl>
          <div class="d-block d-md-none">
            <mjs-apply-button
              [mjsJob]="content">
            </mjs-apply-button>
          </div>
          <div class="job-description wysiwyg-content"
            *ngIf="content && content.description"
            [innerHTML]="content.description | safe">
          </div>
          <div class="position-relative border-top pt-4" *ngIf="content.organisation.field_job_description_suffix" [innerHtml]="content.organisation.field_job_description_suffix"></div>
          <div class="position-relative border-top" *ngIf="content.organisation.accreditations && content.organisation.accreditations.length > 0">
            <ul class="accreditations d-flex justify-content-start flex-wrap">
              <li *ngFor="let item of content.organisation.accreditations">
                <a href="/employer-accreditations" target="_blank">
                  <img
                    defaultImage="/assets/img/defaults/default-icon.svg"
                    [errorImage]="item.image ?? ''"
                    [lazyLoad]="webp.defaultImage(item.image ?? '')"
                    [alt]="item.name"
                  />
                </a>
              </li>
            </ul>
          </div>
          <div *ngIf="content.files.length > 0" class="job-files">
            <h2 class="mjs-heading">Job Attachments</h2>
            <a *ngFor="let item of content.files"
              [href]="item.url"
              class="job-attachment-download btn d-block w-100 text-left text-primary border"
              [attr.data-job]="content.job_number || content.id"
              [attr.data-filename]="item.filename"
              angulartics2On="click"
              angularticsAction="download"
              [angularticsLabel]="'Job Advert ID: ' + content.id + ' Document: ' + item.filename"
              angularticsCategory="Download">
              <svg aria-hidden="true" focusable="false" width="22" height="22" fill="currentColor"
                class="svg-icon mjs-file-text position-absolute start-0 top-50 translate-middle-y ms-2">
                <use xlink:href="/assets/icons/symbol-defs.svg#mjs-file-text"></use>
              </svg>

              <span class="sr-only">Download job attachment </span>{{ filename(item) }} <abbr class="filesize">[{{ item.filesize | filesize }}]</abbr>

            </a>
          </div>
          <div style="margin-bottom: 30px;" *ngIf="content.locations.length > 0 && content.locations[0].coordinates">
            <button
              *ngIf="!map"
              (click)="showMap()"
              class="btn btn-outline-primary">
              <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="mr-2"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon><line x1="8" y1="2" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="22"></line></svg>
              Show on map
            </button>
            <ng-container *ngIf="isBrowser">
              <mjs-apple-map
                *ngIf="map && content && content.locations[0].coordinates"
                [list]="[setGeoLocationCoordinates(content)]">
              </mjs-apple-map>
            </ng-container>
          </div>
        </div>
        <div class="col sidebar">
          <a
            class="job-organisation-logo"
            [routerLink]="content.org_url"
            *ngIf="!mobile && content.organisation">
            <div class="small-org-image">
              <img
                defaultImage="/assets/img/defaults/default-icon.svg"
                [errorImage]="content?.org_logo ?? ''"
                [lazyLoad]="webp.defaultImage(content?.org_logo ?? '')"
                [alt]="content.organisation.title"
              />
            </div>
            <h3>{{ content.organisation.title }}</h3>
          </a>
          <mjs-apply-button
            [mjsJob]="content">
          </mjs-apply-button>
          <mjs-social-share
            [title]="content.meta.title"
            [link]="content.meta.canonical_url"
            [image]="content.meta.image_src"
            [summary]="content.meta.description">
          </mjs-social-share>
          <button class="btn btn-outline-primary btn-block text-left fav"
            (click)="favourite(toInteger(content.id))"
            [ngClass]="{'liked': content.user_like}">
            {{ content.user_like ? 'Unf' : 'F' }}avourite <span class="sr-only" [innerHtml]="content.title + ' - ' + (content.job_number || content.id)"></span>
            <svg aria-hidden="true" focusable="false" class="float-right" height="18" viewBox="0 0 24 24" width="18">
              <path *ngIf="!content.user_like" d="M12 15.422l3.75 2.25-0.984-4.266 3.328-2.906-4.406-0.375-1.688-4.031-1.688 4.031-4.406 0.375 3.328 2.906-0.984 4.266zM21.984 9.234l-5.438 4.734 1.641 7.031-6.188-3.75-6.188 3.75 1.641-7.031-5.438-4.734 7.172-0.609 2.813-6.609 2.813 6.609z"></path>
              <path *ngIf="content.user_like" d="M12 17.25l-6.188 3.75 1.641-7.031-5.438-4.734 7.172-0.609 2.813-6.609 2.813 6.609 7.172 0.609-5.438 4.734 1.641 7.031z"></path>
            </svg>
          </button>
          <div class="job-categories">
            <a *ngIf="content.category" class="text-white" [routerLink]="content?.category?.parent?.[0]?.path ?? ''" [innerHtml]="content?.category?.parent?.[0]?.title ?? ''"></a>
            <a *ngIf="content.category" class="text-white" [routerLink]="content.category.path" [innerHtml]="content.category.title"></a>
          </div>
          <mjs-advert [type]="'doublempu'"></mjs-advert>
        </div>
      </div>
    </div>
  </div>
</article>

